/**
 * CenterColumn - Canonical center-column wrapper
 *
 * Provides consistent symmetric horizontal padding across all
 * reading surfaces (Advisor, Memories, Goals, Numbers).
 *
 * Layout contract:
 * - Symmetric horizontal padding at all breakpoints
 * - w-full (does not impose max-width - that's ProseContainer's job)
 * - No vertical constraints (content determines height)
 */

import { cn } from "@/lib/utils"
import type { ReactNode } from "react"

interface CenterColumnProps {
  children: ReactNode
  className?: string
}

export function CenterColumn({ children, className }: CenterColumnProps) {
  return <div className={cn("w-full px-6 md:px-10 lg:px-12", className)}>{children}</div>
}
